module.exports = __webpack_public_path__ + "img/apple_icon_light.1faadbd7.svg";